import React from "react";

import Introduction from "../../../organisms/teacher/HintModals/Introduction";
import {
  ITeacherSurvey,
  ITeachingHintsGroupWorks,
  ITeachingHintsIntroductions,
} from "../../../state";
import GroupWork from "../../../organisms/teacher/HintModals/GroupWork";
import Welcome from "../../../organisms/teacher/HintModals/Welcome";
import {
  TEACHING_HINTS_MODAL_PAGES,
  TeachingHintsModalPage,
} from "../../../constants/teaching_hint";

type Props = {
  onClose: () => void;
  teachingHint: ITeachingHintsIntroductions | null;
  teachingHintGroupWork: ITeachingHintsGroupWorks | null;
  teacherSurvey: ITeacherSurvey | null;
  onNavigateToSurvey?: () => void;
  teachingHintModalPages?: TeachingHintsModalPage;
};

const ChatBubbleHints: React.FC<Props> = ({
  onClose,
  teachingHint,
  teachingHintGroupWork,
  teacherSurvey,
  onNavigateToSurvey,
  teachingHintModalPages,
}) => {
  const [modal, setModal] = React.useState<TeachingHintsModalPage>(
    teachingHintModalPages ?? TEACHING_HINTS_MODAL_PAGES.WELCOME,
  );

  const renderContent = (): React.ReactElement => {
    switch (modal) {
      case TEACHING_HINTS_MODAL_PAGES.WELCOME:
        return (
          <Welcome
            onClose={onClose}
            onSelectIntroduction={() =>
              setModal(TEACHING_HINTS_MODAL_PAGES.INTRODUCTION)
            }
            onSelectGroupWork={() =>
              setModal(TEACHING_HINTS_MODAL_PAGES.GROUP_WORK)
            }
          />
        );
      case TEACHING_HINTS_MODAL_PAGES.INTRODUCTION:
        return (
          <Introduction
            onBack={() => setModal(TEACHING_HINTS_MODAL_PAGES.WELCOME)}
            onClose={onClose}
            teachingHints={teachingHint}
            onNavigateToSurvey={onNavigateToSurvey}
          />
        );
      case TEACHING_HINTS_MODAL_PAGES.GROUP_WORK:
        return (
          <GroupWork
            onBack={() => setModal(TEACHING_HINTS_MODAL_PAGES.WELCOME)}
            onClose={onClose}
            teachingHintGroupWork={teachingHintGroupWork}
            teacherSurvey={teacherSurvey}
            onNavigateToSurvey={onNavigateToSurvey}
          />
        );
    }
  };

  return <>{renderContent()}</>;
};

export default ChatBubbleHints;
